import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";

export class FilterBarModuleFetchHandler extends FetchHandler {}
